import { render, staticRenderFns } from "./FormularioObrigatorioAssinaturaDigital.vue?vue&type=template&id=4803561c"
import script from "./FormularioObrigatorioAssinaturaDigital.vue?vue&type=script&lang=js"
export * from "./FormularioObrigatorioAssinaturaDigital.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports